<template>
	<div id="collection" class="policy-document">
		<h2>个人信息收集清单</h2>
	
		<div class="policy-content">
			<!-- 修改后的文档信息区域 -->
			<div class="info-box">
				<div class="info-item">
					<text class="info-label">应用运营方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">应用研发方:</text>
					<text class="info-value">深圳乐漂科技有限公司</text>
				</div>
				<div class="info-item">
					<text class="info-label">注册地址:</text>
					<text class="info-value">深圳市南山区粤海街道高新区社区高新南七道020号高新工业村R2-A座210</text>
				</div>
				<div class="info-item">
					<text class="info-label">联系方式:</text>
					<text class="info-value">dev@ledrift.net</text>
				</div>
			</div>
			<!-- 文档内容保持不变 -->
			<h3>引言</h3>
			<p>根据国家相关法律法规要求，以下是"乐漂出行"App收集和使用个人信息的清单。</p>
	
			<h3>一、收集的个人信息类型及用途</h3>
			<p><strong>1. 手机号码</strong></p>
			<p>用途：用于注册/登录账号、接收服务通知</p>
			<p>收集方式：用户输入</p>
			<p>是否必需：是</p>
	
			<p><strong>2. 位置信息（精确/粗略）</strong></p>
			<p>用途：定位车辆、导航寻车、记录轨迹、电子围栏</p>
			<p>收集方式：用户授权后通过设备系统获取</p>
			<p>是否必需：核心功能必需</p>
	
			<p><strong>3. 蓝牙信息</strong></p>
			<p>用途：扫描、发现、连接并控制智能车辆</p>
			<p>收集方式：用户授权后通过设备系统获取</p>
			<p>是否必需：核心功能必需</p>
	
			<p><strong>4. 设备信息（设备型号、OS版本、唯一设备标识符)</strong></p>
			<p>用途：保障账号与交易安全、识别App崩溃、数据统计分析</p>
			<p>收集方式：App自动收集</p>
			<p>是否必需：是</p>
	
			<p><strong>5. 服务日志信息（操作记录、IP地址）</strong></p>
			<p>用途：维护服务正常运行、安全分析、优化服务</p>
			<p>收集方式：App自动收集</p>
			<p>是否必需：是</p>
	
			<p><strong>6. 订单支付信息（订单号、金额、时间）</strong></p>
			<p>用途：完成消费支付、订单查询与管理</p>
			<p>收集方式：用户与第三方支付平台交互产生</p>
			<p>是否必需：是</p>
	
			<h3>二、说明</h3>
			<p>"必需"是指缺少该信息会导致相关核心功能无法实现。</p>
			<p>您可以通过设备操作系统设置随时关闭位置、蓝牙等权限，但这将影响对应功能的正常使用。</p>
	
			<p class="highlight-text">生效日期：2025年05月01日</p>
		</div>
	</div>

</template>



<style>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
	}

	body {
		background-color: #f5f7fa;
		color: #333;
		line-height: 1.6;
		padding: 20px;
	}

	.policy-document {
		border-radius: 12px;
		padding: 40px;
		margin-bottom: 40px;
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
		background-color: #ffffff;
	}

	.policy-document h2 {
		color: #2c3e50;
		margin-bottom: 20px;
		text-align: center;
		font-size: 1.8rem;
	}

	.policy-content {
		padding: 20px;
		background: #f9f9f9;
		border-radius: 8px;
	}

	.info-box {
		width: 100%;
		padding: 20px;
		background: #e7f4fc;
		border-radius: 8px;
		margin-bottom: 25px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.info-item {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		line-height: 1.8;
	}

	.info-item:last-child {
		margin-bottom: 0;
	}

	.info-label {
		font-weight: 600;
		min-width: 100px;
		flex-shrink: 0;
		color: #333;
	}

	.info-value {
		flex-grow: 1;
		word-break: break-word;
		color: #666;
	}

	.policy-content h3 {
		color: #3498db;
		margin: 20px 0 10px;
	}

	.policy-content p {
		margin-bottom: 15px;
	}

	.back-button {
		display: inline-block;
		margin-top: 20px;
		background: #7f8c8d;
		color: white;
		padding: 10px 18px;
		border-radius: 6px;
		text-decoration: none;
		transition: background 0.3s ease;
	}

	.back-button:hover {
		background: #636e72;
	}

	.page-footer {
		text-align: center;
		padding: 20px;
		color: #7f8c8d;
		font-size: 0.9rem;
		border-top: 1px solid #ddd;
		margin-top: 20px;
	}

	.company-details {
		margin-top: 30px;
		padding: 20px;
		background: white;
		border-radius: 10px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	.company-details h3 {
		color: #2c3e50;
		margin-bottom: 15px;
		text-align: center;
	}

	.company-details p {
		margin: 10px;
	}

	.highlight-text {
		color: #e74c3c;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.container {
			grid-template-columns: 1fr;
		}

		h1 {
			font-size: 2rem;
		}

		.policy-document {
			padding: 20px;
		}

		.info-box {
			padding: 15px;
		}

		.info-label {
			min-width: 90px;
			margin-bottom: 5px;
		}

		.info-item {
			flex-direction: column;
			margin-bottom: 15px;
		}
	}
</style>
    